import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useState } from 'react';
import { getAgentElement, getExtraSituationalAwarenessContext, updateExtraSituationalAwarenessContext } from 'utils/mindset';
export function useOpenMindsetAgent(agentElementId, addAgentIfRequired) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasInitialized = _useState2[0],
    setHasInitialized = _useState2[1];
  var _useState3 = useState('loading'),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingStatus = _useState4[0],
    setLoadingStatus = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var handleOpen = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _agentEl$newThread;
    var message,
      silent,
      threadTitle,
      coachingContext,
      agentEl,
      _agentEl$setSituation,
      sendWhenIdle,
      _args = arguments,
      _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sendWhenIdle = function _sendWhenIdle() {
            var _agentEl$isAgentBusy;
            if (!(agentEl !== null && agentEl !== void 0 && (_agentEl$isAgentBusy = agentEl.isAgentBusy) !== null && _agentEl$isAgentBusy !== void 0 && _agentEl$isAgentBusy.call(agentEl))) {
              var _agentEl$sendMessage;
              if (threadTitle) {
                agentEl === null || agentEl === void 0 || agentEl.addEventListener('mindset:thread-changed', function (e) {
                  var threadUid = e.detail.threadUid;
                  if (threadUid) {
                    var _agentEl$renameThread;
                    agentEl === null || agentEl === void 0 || (_agentEl$renameThread = agentEl.renameThread) === null || _agentEl$renameThread === void 0 || _agentEl$renameThread.call(agentEl, threadUid, threadTitle);
                  }
                }, {
                  once: true
                });
              }
              agentEl === null || agentEl === void 0 || (_agentEl$sendMessage = agentEl.sendMessage) === null || _agentEl$sendMessage === void 0 || _agentEl$sendMessage.call(agentEl, message, {
                silent: silent
              });
              setLoadingStatus('ready');
            } else {
              agentEl === null || agentEl === void 0 || agentEl.addEventListener('mindset:agent-idle', sendWhenIdle, {
                once: true
              });
            }
          };
          message = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
          silent = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          threadTitle = _args.length > 2 && _args[2] !== undefined ? _args[2] : '';
          coachingContext = _args.length > 3 && _args[3] !== undefined ? _args[3] : '';
          setIsOpen(true);

          // Update extra context immediately — before any await — so it is already
          // in extraContext when setHasInitialized(true) triggers a re-render and
          // useMindsetLocationContext fires setSituationalAwareness. Without this
          // early update, that effect fires with extraContext={} and clears
          // coachingContext from the agent's awareness before sendMessage runs.
          // coachingContext is intentionally left in extraContext after sendMessage
          // so it persists while the AI generates its response; the next handleOpen
          // call will overwrite or clear it.
          updateExtraSituationalAwarenessContext({
            coachingContext: coachingContext || undefined
          });
          if (hasInitialized) {
            _context.next = 4;
            break;
          }
          setLoadingStatus('loading');
          _context.prev = 1;
          _context.next = 2;
          return addAgentIfRequired();
        case 2:
          setHasInitialized(true);
          setLoadingStatus('ready');
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          // Clear coachingContext so it doesn't leak into other surfaces
          // if initialization fails before the agent is ever shown.
          updateExtraSituationalAwarenessContext({
            coachingContext: undefined
          });
          setLoadingStatus('error');
          return _context.abrupt("return");
        case 4:
          if (message) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return");
        case 5:
          agentEl = getAgentElement(agentElementId);
          _context.next = 6;
          return agentEl === null || agentEl === void 0 || (_agentEl$newThread = agentEl.newThread) === null || _agentEl$newThread === void 0 ? void 0 : _agentEl$newThread.call(agentEl);
        case 6:
          // Direct setSituationalAwareness call is still needed as an immediate
          // sync right before sendMessage, since the React re-render triggered by
          // updateExtraSituationalAwarenessContext above may not have flushed yet.
          if (coachingContext) {
            agentEl === null || agentEl === void 0 || (_agentEl$setSituation = agentEl.setSituationalAwareness) === null || _agentEl$setSituation === void 0 || _agentEl$setSituation.call(agentEl, _objectSpread({
              currentRoute: window.location.pathname
            }, getExtraSituationalAwarenessContext()));
          }

          // SDK-docs pattern: sendMessage is synchronous and throws if the agent is busy.
          // An icebreaker greeting fires after newThread() — the agent may be briefly idle
          // then immediately busy. Recurse on mindset:agent-idle so we always send after
          // the agent settles, regardless of whether an icebreaker runs.
          //
          // The rename listener is registered here, right before sendMessage, so it can't
          // accidentally catch icebreaker events.

          sendWhenIdle();
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  })), [hasInitialized, agentElementId, addAgentIfRequired]);
  return {
    loadingStatus: loadingStatus,
    setLoadingStatus: setLoadingStatus,
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    hasInitialized: hasInitialized,
    setHasInitialized: setHasInitialized,
    handleOpen: handleOpen
  };
}